import autobind from 'core-decorators/lib/autobind';


const fullScreenChangeEventsList = ['fullscreenchange', 'mozfullscreenchange', 'webkitfullscreenchange', 'msfullscreenchange'];
const iosFullscreenChangeEventsList = ['webkitbeginfullscreen', 'webkitendfullscreen'];


export default class FullscreenTracker extends React.Component {
  static propTypes = {
    videoRef: React.PropTypes.any,
    onFullscreenChanged: _.noop,
  };

  componentWillMount() {
    this.addFullscreenEventHandler();
  }

  componentWillReceiveProps(nextProps) {
    const prevVideoRef = this.props.videoRef;
    const nextVideoRef = nextProps.videoRef;

    if (prevVideoRef !== nextVideoRef) {
      if (prevVideoRef) {
        this.removeFullscreenEventHandlerForIOS(prevVideoRef);
      }
      if (nextVideoRef) {
        this.addFullscreenEventHandlerForIOS(nextVideoRef);
      }
    }
  }

  componentWillUnmount() {
    this.removeFullscreenEventHandler();
    if (this.props.videoRef) {
      this.removeFullscreenEventHandlerForIOS(this.props.videoRef);
    }
  }

  @autobind
  handleFullscreenChange() {
    this.props.onFullscreenChanged();
  }

  addFullscreenEventHandler() {
    _.forEach(fullScreenChangeEventsList, eventName => (
      document.addEventListener(eventName, this.handleFullscreenChange)
    ));
  }

  removeFullscreenEventHandler() {
    _.forEach(fullScreenChangeEventsList, eventName => (
      document.removeEventListener(eventName, this.handleFullscreenChange)
    ));
  }

  addFullscreenEventHandlerForIOS(element) {
    _.forEach(iosFullscreenChangeEventsList, eventName => (
      element.addEventListener(eventName, this.handleFullscreenChange)
    ));
  }

  removeFullscreenEventHandlerForIOS(element) {
    _.forEach(iosFullscreenChangeEventsList, eventName => (
      element.removeEventListener(eventName, this.handleFullscreenChange)
    ));
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/fullscreen/fullscreen-changed-tracker.js